// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  display: inline-block;
}
.root :global .pictureWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #EAEFF3;
}
.root :global .pictureWrapper i {
  color: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/FAIconPicture.less"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;AAAA;EAIM,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AADN;AAPA;EAWQ,cAAA;AADR","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.root {\n  display: inline-block;\n  :global {\n    .pictureWrapper {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      overflow: hidden;\n      background-color: @background-gray2;\n\n      i {\n        color: @text-white;\n      }\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
